import {ControlledSwitch} from '@hm/fundamental'

import {StaticPartComponentTypeEnum} from '@refra/modules/refra-static-parts/enums'
import {useSelectedComponent} from '@refra/modules/refra-static-parts/providers'

export const StaticPartDetailComponentSwitch = () => {
  const {selectedComponentType, switchOptions, setSelectedComponentType} = useSelectedComponent()

  return (
    <>
      <ControlledSwitch
        value={selectedComponentType}
        name={'static_part_component_switch'}
        options={switchOptions}
        onChange={(value) => setSelectedComponentType(value as StaticPartComponentTypeEnum)}
      />
    </>
  )
}
